import { Tabs } from 'antd';
import { NotificationListCustomerTable } from 'features/notification/components/notification-list-table/customer-table';
import { NotificationTopBarCustomer } from 'features/notification/components/top-bar/notification-customer-top-bar';
import { NotificationCustomerFilterFormValuesPaginated } from 'features/notification/components/type';
import { useGetNotificationCustomerList } from 'features/notification/use-cases/get-customer-list';
import { useGetSelectedCustomerList } from 'features/notification/use-cases/get-selected-customer-list';
import { usePaginationParams } from 'hooks';
import { useEffect, useState } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';

const getInitialFilterValues: any = {
    SportCategoryIds: undefined,
    EventIds: undefined,
    TicketCategoryIds: undefined,
    AgeGroupIds: undefined,
    GenderId: undefined,
    Nationality: undefined,
    CustomerName: undefined,
    customertype: undefined,
    SessionId: undefined,
    emailId: undefined,
    paymentStatus: undefined,
};

export const CustomerViewList = () => {
    const [sessionId, setSessionId] = useState<string | null>(
        localStorage.getItem('sessionId')
    );

    const [activeTab, setActiveTab] = useState('1');
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [searchParams, setSearchParams] = useSearchParams();

    const {
        params,
        updateParams,
    } = usePaginationParams<any>({
        page: 1,
        size: 10,
        order_by: 'id',
        ...getInitialFilterValues,
    });

    const {
        params: selectedCustomerParam,
        updateParams: selectedUpdateParam,
    } = usePaginationParams<NotificationCustomerFilterFormValuesPaginated>({
        page: 1,
        size: 10,
        order_by: 'id',
        ...getInitialFilterValues,
    } as any);

    // Get sessionId from localStorage
    useEffect(() => {
        const storedSessionId = localStorage.getItem('sessionId');

       

        if (storedSessionId) {
            setSessionId(storedSessionId);
        }
    }, []);

    // Update params when sessionId is available
    useEffect(() => {
        if (!sessionId) {
            return;
        }

      

        updateParams({
            SessionId: sessionId,
        });

        selectedUpdateParam({
            SessionId: sessionId,
        } as any);
    }, [sessionId]);

    const {
        data,
        refetch,
        isFetching,
    } = useGetNotificationCustomerList(
        {
            ...params,
            SessionId: sessionId,
            paymentStatus: params.paymentStatus ?? 1,
        },
        {
            retry: false,
            enabled: !!sessionId && activeTab === '1',
        }
    );

    const {
        data: selectedCustomerList,
        refetch: selectedCustomerListRefetch,
        isFetching: selectedCustomerListIsFetching,
    } = useGetSelectedCustomerList(
        {
            ...selectedCustomerParam,
            SessionId: sessionId,
        } as any,
        {
            retry: false,
            enabled: !!sessionId && activeTab === '2',
        }
    );

    const handleFiltersChange = (
        values: NotificationCustomerFilterFormValuesPaginated
    ) => {
        if (activeTab === '1') {
            updateParams({
                ...values,
                SessionId: sessionId,
            });

            refetch();
        } else {
            selectedUpdateParam({
                ...values,
                SessionId: sessionId,
            } as any);

            selectedCustomerListRefetch();
        }
    };

    useEffect(() => {
        const tab = searchParams.get('tab') || '1';

        setActiveTab(tab);
        setSelectedRowKeys([]);
    }, [searchParams]);

    return (
        <>
            <NotificationTopBarCustomer
                handleFilter={handleFiltersChange}
                getInitialFilterValues={getInitialFilterValues}
            />

            <Tabs
                activeKey={activeTab}
                onChange={(key) => {
                    setActiveTab(key);
                    setSearchParams({ tab: key });

                    if (key === '2') {
                        selectedCustomerListRefetch();
                    } else {
                        refetch();
                    }
                }}
                items={[
                    {
                        key: '1',
                        label: 'All Participant',
                        children: (
                            <NotificationListCustomerTable
                                isUsersListLoading={isFetching}
                                typeReportList={data?.items as any}
                                itemsCount={data?.total as number}
                                tableParams={params}
                                refetch={refetch}
                                updateParams={updateParams}
                                selectedRowKeys={selectedRowKeys}
                                setSelectedRowKeys={setSelectedRowKeys}
                                uniqueDeviceCount={
                                    (data as any)?.UniqueDeviceCount as number
                                }
                                tabKey={1}
                            />
                        ),
                    },
                    {
                        key: '2',
                        label: 'Selected Participant',
                        children: (
                            <NotificationListCustomerTable
                                isUsersListLoading={selectedCustomerListIsFetching}
                                typeReportList={selectedCustomerList?.items as any}
                                itemsCount={selectedCustomerList?.total as number}
                                tableParams={selectedCustomerParam}
                                refetch={selectedCustomerListRefetch}
                                updateParams={selectedUpdateParam}
                                tabKey={2}
                                selectedRowKeys={selectedRowKeys}
                                setSelectedRowKeys={setSelectedRowKeys}
                                uniqueDeviceCount={
                                    (selectedCustomerList as any)
                                        ?.UniqueDeviceCount as number
                                }
                            />
                        ),
                    },
                ]}
            />

            <Outlet />
        </>
    );
};